import { useQuery } from '@tanstack/react-query';
import { isImpersonating, endImpersonation } from '../lib/impersonation';
import { apiCall } from '../lib/api';

/**
 * Sticky red banner shown at the top of every LIFF page when the session
 * is an admin impersonation. Reminds admin they're not the real user and
 * gives a quick way out.
 */
export function ImpersonationBanner() {
  if (!isImpersonating()) return null;
  return <BannerInner />;
}

interface MeResp {
  customer?: { first_name?: string; last_name?: string } | null;
}

function BannerInner() {
  const me = useQuery<MeResp>({
    queryKey: ['imp', 'me'],
    queryFn: async () => {
      try { return await apiCall<MeResp>('get', '/customers/me'); }
      catch { return {} as MeResp; }
    },
    staleTime: 60_000,
    retry: 0,
  });
  const c = me.data?.customer;
  const name = c ? `${c.first_name ?? ''} ${c.last_name ?? ''}`.trim() : '';

  return (
    <div
      className="sticky top-0 z-50 bg-red-600 text-white px-3 py-2 flex items-center gap-2 text-xs font-medium shadow-md"
    >
      <span className="text-base leading-none">🔓</span>
      <span className="flex-1 truncate">
        โหมด Admin Impersonation
        {name && <span className="opacity-80"> · {name}</span>}
      </span>
      <button
        onClick={endImpersonation}
        className="bg-white/20 hover:bg-white/30 px-2.5 py-1 rounded font-semibold text-[11px]"
      >
        ออกจากโหมด
      </button>
    </div>
  );
}
